export const COMPLETE_SUBSCRIPTION_ROUTE = {
  TITLE: "Complete Subscription",
  KEY: "complete-subscription",
  ABSOLUTE_PATH: "/complete-subscription",
  PARENT_PATH: "complete-subscription/*",
};
